import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "@/messages/en.json";
import sw from "@/messages/sw.json";

export const LANG_STORAGE_KEY = "anga_lang";

export type AppLanguage = "en" | "sw";

function readStoredLanguage(): AppLanguage {
  if (typeof window === "undefined") return "en";
  const stored = localStorage.getItem(LANG_STORAGE_KEY);
  return stored === "sw" ? "sw" : "en";
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    sw: { translation: sw },
  },
  lng: typeof window !== "undefined" ? readStoredLanguage() : "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  initAsync: false,
  react: {
    useSuspense: false,
  },
});

export function setAppLanguage(lng: AppLanguage) {
  if (typeof window !== "undefined") {
    localStorage.setItem(LANG_STORAGE_KEY, lng);
  }
  void i18n.changeLanguage(lng);
}

export default i18n;
